import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import { Box } from '../../../../components/UI-CHAKRA/Box';
import { Button } from '../../../../components/UI-CHAKRA/Button';
import { Flex } from '../../../../components/UI-CHAKRA/Flex';
import { IconButton } from '../../../../components/UI-CHAKRA/IconButton';
import { Text } from '../../../../components/UI-CHAKRA/Text';
import { SNCR_COLORS, SNCR_TEXTS } from '../constants';
import { ReactComponent as Nerdium } from '../../../../assets/images/icons/nerdium.svg';
import { ReactComponent as CheckedShield } from '../../../../assets/images/icons/checked-shield.svg';
import { APP_VIEWPORT_HEIGHT } from '../../../../helpers/embeddedViewport';

interface SncrAuthRequiredModalProps {
  onAuthenticate(): void;
  onDismiss(): void;
}

/**
 * Modal exibido antes de solicitar numerações quando o prescritor ainda não
 * está autenticado no Gov.br. A ação principal deve disparar a abertura do
 * popup de autenticação a partir do gesto do usuário (evita bloqueio de popup).
 *
 * @param onAuthenticate - Confirma e abre o fluxo de autenticação Gov.br.
 * @param onDismiss - Fecha o modal sem autenticar.
 */
export function SncrAuthRequiredModal({ onAuthenticate, onDismiss }: SncrAuthRequiredModalProps) {
  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height={APP_VIEWPORT_HEIGHT}
      zIndex={1500}
      bg={SNCR_COLORS.overlay}
      alignItems="center"
      justifyContent="center"
    >
      <Box bg="white" borderRadius="16px" padding="20px" width="100%" maxWidth="381px" position="relative">
        <IconButton
          aria-label="Fechar"
          variant="ghost"
          size="sm"
          icon={<CloseIcon boxSize="12px" color="primary.main" />}
          position="absolute"
          top="16px"
          right="16px"
          onClick={onDismiss}
        />

        <Flex direction="column" gap="24px" alignItems="center">
          <Nerdium />
          <Flex direction="column" gap="10px">
            <Text fontSize="16px" fontWeight={700} textAlign="start" color={SNCR_COLORS.primary}>
              {SNCR_TEXTS.authRequiredTitle}
            </Text>
            <Text fontSize="14px" textAlign="start" color={SNCR_COLORS.supportDark}>
              {SNCR_TEXTS.authRequiredDescription}
            </Text>
          </Flex>
          <Button width="100%" display="flex" gap="1px" size="sm" borderRadius="full" bg={SNCR_COLORS.primary} color="white" onClick={onAuthenticate}>
            <CheckedShield />
            {SNCR_TEXTS.authenticateViaGovBr}
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}
